import { render } from "./CommonDialog.vue?vue&type=template&id=265a5b34"
import script from "./CommonDialog.vue?vue&type=script&lang=js"
export * from "./CommonDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__